import { createi18nInstance } from '@pletly/common';
import { resources } from './locales/index';

const defaultNS = 'ui';

const i18n = createi18nInstance({
	resources,
	defaultNS,
});

export default i18n;
